import React from 'react';
import { Link } from 'react-router-dom';
import { Youtube, BookOpen, Sparkles, Newspaper, ArrowRight } from 'lucide-react';

const publications = [
  {
    title: 'YouTube Channel',
    subtitle: 'Video reflections & lectures',
    description: 'Subscribe to our official YouTube channel for theology seminars, spiritual reflections, and campus events.',
    icon: <Youtube size={32} className="text-danger" />,
    link: '/publications/youtube'
  },
  {
    title: 'Vidyajyoti Journal',
    subtitle: 'Journal of Theological Reflection',
    description: 'VJTR is a premier peer-reviewed research journal promoting Indian and Asian contextual Christian theologizing.',
    icon: <BookOpen size={32} style={{ color: '#1a2b56' }} />,
    link: '/publications/vj-journal'
  },
  {
    title: 'AVE Reflections',
    subtitle: 'Daily Scripture Meditations',
    description: 'A monthly publication authored by students offering insightful meditations on the daily lectionary readings.',
    icon: <Sparkles size={32} style={{ color: '#c69214' }} />,
    link: '/publications/ace'
  },
  {
    title: 'VJ Today',
    subtitle: 'Student Newsletter',
    description: 'Showcases student reflections, literary contributions, campus activities, and pastoral experiences.',
    icon: <Newspaper size={32} style={{ color: '#79031d' }} />,
    link: '/publications/vjtoday'
  }
];

export default function Services() {
  return (
    <section className="services py-5 my-3">
      <div className="container">
        <div className="text-center mx-auto pb-5" style={{ maxWidth: '700px' }}>
          <span className="text-burgundy fw-bold text-uppercase small" style={{ letterSpacing: '0.1em' }}>
            ACADEMIC & PASTORAL PUBLICATIONS
          </span>
          <h2 className="vj-card-title display-6 fw-bold mt-1 text-dark-main">
            Publications Built For Your Learning
          </h2>
          <p className="text-muted mt-2">
            Explore our rich theological journals, daily meditations, and multimedia resources produced by faculty and scholars.
          </p>
        </div>

        <div className="row g-4">
          {publications.map((item, idx) => (
            <div className="col-lg-3 col-md-6 d-flex" key={idx}>
              <div className="services-item w-100 d-flex flex-column">
                <div className="services-content">
                  <div className="services-content-icon">
                    <div 
                      className="d-inline-flex align-items-center justify-content-center p-3 rounded-circle mb-2"
                      style={{ background: '#f8fafc', border: '1px solid #e2e8f0' }}
                    >
                      {item.icon}
                    </div>
                  </div>
                  <h4 className="fw-bold fs-5 mb-1 text-dark">{item.title}</h4>
                  <span className="text-muted small fw-semibold mb-3 d-block">{item.subtitle}</span>
                  <p className="text-muted flex-grow-1 line-clamp-3 small mb-4">
                    {item.description}
                  </p>
                  <div className="mt-auto">
                    <Link to={item.link} className="vj-btn-outline w-100 justify-content-center">
                      Read More <ArrowRight size={15} />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
